import { render, staticRenderFns } from "./MtqrAdd.vue?vue&type=template&id=c56103fa&scoped=true&"
import script from "./MtqrAdd.vue?vue&type=script&lang=js&"
export * from "./MtqrAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56103fa",
  null
  
)

export default component.exports